import UiLib from '@ai/ui-components'
import type { PropsOf } from '@/types/typeUtils'
import { ACTION_BUTTON_ICONS } from './actionButtonIconsConfig'

type UiIconProps = PropsOf<(typeof UiLib)['UiIcon']>
type ActionButtonIconKey = keyof typeof ACTION_BUTTON_ICONS

interface ListActionIconBinding {
  icon: ActionButtonIconKey
  color?: UiIconProps['color']
}

/**
 * Icons config rendered inside `OListActions` dropdown.
 * Reuses keys from `actionButtonIconsConfig.ts`, so direct action buttons and
 * dropdown actions stay icon-synchronized from one canonical icon namespace.
 */
export const LIST_ACTION_ICONS = {
  edit: { icon: 'edit' },
  duplicate: { icon: 'duplicate' },
  preview: { icon: 'preview' },
  import: { icon: 'import' },
  download: { icon: 'download' },
  liveTest: { icon: 'liveTest' },
  export: { icon: 'export' },
  copyLink: { icon: 'copyLink' },
  listen: { icon: 'listen' },
  details: { icon: 'details' },
  phone: { icon: 'phone' },
  report: { icon: 'report' },
  unassignDanger: { icon: 'unassign', color: '!text-primary-error' },
  deleteDanger: { icon: 'delete', color: '!text-primary-error' },
} as const satisfies Record<string, ListActionIconBinding>
